import React from 'react';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import { func, bool, object } from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import SlidePanel from '../SlidePanel/SlidePanel';
import CMCouponPanelHeader from './CMCouponPanelHeader';
import CMCouponTierDetails from './CMCouponTierDetails';
import { getCouponExpirationDate } from './pageUtils';
import * as styles from './CMCouponDetails.css';

const cx = classNames.bind(styles);

const CMCouponDetails = (props) => {
    const { contentItem = {} } = props;
    const renderHeader = () => {
        return (
            <CMCouponPanelHeader
                onClosePanel={() => props.setShowDetailsPanel(false)}
                data-automation-id="at-slider-header"
            />
        );
    };
    const renderContent = () => {
        return (
            <div className={dt(['pt-3', 'smOnly:pt-4', 'px-6', 'overflow-auto'])}>
                {contentItem?.teaserTitle ? (
                    <p
                        className={dt([
                            'lg:text-xlarge',
                            'smMd:text-xlarge',
                            'md:leading-8',
                            'font-semibold',
                        ])}
                        data-automation-id="at-slider-teaser-title"
                    >
                        {contentItem?.teaserTitle}
                    </p>
                ) : null}
                <div className={dt([contentItem?.teaserTitle ? 'pt-4' : ''])}>
                    <CMCouponTierDetails item={contentItem} isSlider />
                </div>
                <div className={dt(['pt-4'])}>
                    <p className={dt(['text-sm', 'font-normal', 'leading-5'])}>
                        {contentItem?.promoCode ? (
                            <span>
                                Code:{' '}
                                <span
                                    className={dt(['font-bold'])}
                                    data-automation-id="at-slider-promo-code"
                                >
                                    {contentItem?.promoCode}
                                </span>
                            </span>
                        ) : null}
                        {contentItem?.validTo ? (
                            <span
                                className={dt(['pl-1'])}
                                data-automation-id="at-slider-coupon-expiry"
                            >
                                Expires{' '}
                                <span className={dt(['font-bold'])}>
                                    {getCouponExpirationDate(contentItem?.validTo)}
                                </span>
                            </span>
                        ) : null}
                    </p>
                </div>
                {!isEmpty(contentItem?.disclaimerText?.html) ? (
                    <div
                        className={dt(['pt-4', 'text-sm', 'leading-5'])}
                        dangerouslySetInnerHTML={{ __html: contentItem?.disclaimerText?.html }}
                        data-automation-id="at-slider-disclaimer"
                    />
                ) : null}
            </div>
        );
    };
    return (
        <SlidePanel
            isOpenPanel={props.showDetailsPanel}
            panelIcon="close"
            panelHeaderRenderer={() => renderHeader()}
            onClosePanel={() => props.setShowDetailsPanel(false)}
            panelWidth={cx('panelWidth')}
        >
            {renderContent()}
        </SlidePanel>
    );
};

CMCouponDetails.defaultProps = {
    setShowDetailsPanel: noop,
    showDetailsPanel: false,
    contentItem: {},
};

CMCouponDetails.propTypes = {
    setShowDetailsPanel: func,
    showDetailsPanel: bool,
    contentItem: object,
};

export default CMCouponDetails;
